import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { getTumbleDrying1StationDetails } from "../ProductionLine/services";

const TumbleDrying = ({ data, setTumbleData }) => {
  return (
    <>
      <div className="modal-container" style={{ height: "40vh", top: "35vh" }}>
        <div className="modal-header">
          <div className="modal-title">TUMBLE DRYING PROCESS SHEET</div>
          <div
            onClick={() => setTumbleData(false)}
            style={{ cursor: "pointer" }}
          >
            <CloseIcon />
          </div>
        </div>
        <div className="modal-table-wrapper">
          <div
            style={{
              width: "100%",
              overflow: "auto",
              maxHeight: "400px",
            }}
            className="gloves-report-data"
          >
            <Table className="dipping-params">
              <TableHead>
                <TableRow>
                  <TableCell>Max temp</TableCell>
                  <TableCell>Min temp</TableCell>

                  <TableCell>Time Minutes</TableCell>

                  <TableCell>Cycle Start Time</TableCell>
                  <TableCell>Cycle End Time</TableCell>
                  <TableCell>Operator</TableCell>
                  <TableCell>Supervisor</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="gloves-report-body">
                {data?.map((e) => {
                  console.log("shdjkasdjksj", e);
                  return (
                    <TableRow>
                      <TableCell>{e.max_temp ? e.max_temp : "--"}</TableCell>
                      <TableCell>{e.min_temp ? e.min_temp : "--"}</TableCell>
                      <TableCell>
                        {e.time_minutes ? e.time_minutes : "--"}
                      </TableCell>

                      <TableCell>
                        {e
                          ? e?.cycle_start_time
                            ? dayjs(e.cycle_start_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>
                        {e
                          ? e?.cycle_end_time
                            ? dayjs(e.cycle_end_time).format("HH:mm:ss")
                            : "--"
                          : "--"}
                      </TableCell>
                      <TableCell>{e.operator ? e.operator : "--"}</TableCell>
                      <TableCell>
                        {e.supervisor ? e.supervisor : "--"}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
      <div className="modal-overlay" onClick={() => setTumbleData(false)}></div>
    </>
  );
};

export default TumbleDrying;
